import { IStatusBarInfo } from "../models/IStatusBarInfo";
import { AnyAction } from 'redux';
import { ActionTypes } from "../constants/ActionTypes";

export function StatusReducer(state: IStatusBarInfo | null = null, action: AnyAction): IStatusBarInfo | null {
    if (action.type === ActionTypes.SET_STATUS_BAR) {
        return action.payload;
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/reducers/StatusReducer.tsx